var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-row",
    { staticStyle: { width: "100%" }, attrs: { gutter: 10 } },
    [
      _c(
        "el-col",
        { attrs: { xs: 24, sm: 24, md: 12, lg: 8, xl: 8 } },
        [_vm._t("default")],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }